import Api from "../../openapi";
import { cleanSession } from "../../utils/tokenStore";

export default function useUser() {
  const getUser = async () => {
    try {
      const req = await Api.AdminUser.getUser();
      const userInfo = req.data;
      return userInfo;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        cleanSession();
      }
    }
  };

  return { getUser };
}
